<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SearchDateRangeSelector from './SearchDateRangeSelector.vue';
import SearchContactAgentSelector from './SearchContactAgentSelector.vue';
import SearchInboxSelector from './SearchInboxSelector.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['updateFilters']);
const { t } = useI18n();

const filters = defineModel({
  type: Object,
  default: () => ({
    from: null, // Contact id and Agent id
    in: null, // Inbox id
    dateRange: { type: null, from: null, to: null },
  }),
});

const hasActiveFilters = computed(
  () =>
    filters.value.from ||
    filters.value.in ||
    filters.value.dateRange?.type ||
    filters.value.dateRange?.from ||
    filters.value.dateRange?.to
);

const onFilterChange = () => {
  emit('updateFilters', filters.value);
};

const clearAllFilters = () => {
  filters.value = {
    from: null,
    in: null,
    dateRange: { type: null, from: null, to: null },
  };
  onFilterChange();
};
</script>

<template>
  <div
    class="relative flex w-full min-w-0 flex-wrap items-center gap-x-2 gap-y-2"
  >
    <SearchDateRangeSelector
      v-model="filters.dateRange"
      class="min-w-0 max-w-full"
      @change="onFilterChange"
    />

    <div class="hidden h-4 w-px flex-shrink-0 bg-polaris-border sm:block" />

    <span
      class="flex-shrink-0 whitespace-nowrap type-polaris-caption text-polaris-muted-foreground"
    >
      {{ t('SEARCH.FILTERS.FILTER_MESSAGE') }}
    </span>

    <SearchContactAgentSelector
      v-model="filters.from"
      class="min-w-0"
      :label="$t('SEARCH.FILTERS.FROM')"
      @change="onFilterChange"
    />

    <SearchInboxSelector
      v-model="filters.in"
      class="min-w-0"
      :label="$t('SEARCH.FILTERS.IN')"
      @change="onFilterChange"
    />

    <Button
      v-if="hasActiveFilters"
      sm
      slate
      ghost
      :label="t('SEARCH.DATE_RANGE.CLEAR_FILTER')"
      icon="i-lucide-x"
      class="flex-shrink-0"
      @click="clearAllFilters"
    />
  </div>
</template>
